import { useState, useEffect } from 'react';
import { apiFetch } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';

/**
 * Comparison table of all campaigns (superadmin only).
 * Shows name, client count, unit count, progress, and problems.
 */
export default function CampaignComparison() {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isSuperadmin = user?.globalRole === 'superadmin';

  useEffect(() => {
    if (!isSuperadmin) {
      setLoading(false);
      return;
    }
    apiFetch('/campaigns/comparison')
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [isSuperadmin]);

  if (!isSuperadmin) return null;
  if (loading) return <p className="text-gray-500 text-center py-4">Chargement comparaison...</p>;
  if (error) return <p className="text-red-600 text-center py-4">{error}</p>;
  if (data.length === 0) return null;

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h3 className="font-semibold mb-3">Comparaison campagnes</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left text-gray-500">
              <th className="pb-2">Campagne</th>
              <th className="pb-2 text-right">Clients</th>
              <th className="pb-2 text-right">Unités</th>
              <th className="pb-2 text-right">Progression</th>
              <th className="pb-2 text-right">Problèmes</th>
            </tr>
          </thead>
          <tbody>
            {data.map((c) => (
              <tr key={c.id} className="border-b last:border-0">
                <td className="py-2 font-medium">{c.name}</td>
                <td className="py-2 text-right">{c.totalClients}</td>
                <td className="py-2 text-right">{c.deliveredUnits}/{c.totalUnits}</td>
                <td className="py-2 text-right">
                  <span className={c.progressPercent >= 80 ? 'text-green-600 font-bold' : ''}>
                    {c.progressPercent}%
                  </span>
                </td>
                <td className="py-2 text-right">
                  <span className={c.problemCount > 0 ? 'text-red-600' : ''}>
                    {c.problemCount}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
